<mat-icon class="material-icons-outlined">backspace</mat-icon>